import { array, bool, func, number, string } from 'prop-types'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Conditional from '../../Conditional'
import InfiniteList from '../../InfiniteList'
import Loader from '../../Loader'
import { kuiperClassNames } from '../../utils'
import ErrorDisplay from '../ErrorDisplay'
import FileListItem from '../FileListItem'

import './styles.scss'

const transitionName = (lastPath, currentPath) =>
  kuiperClassNames(currentPath.length > lastPath.length ? 'forward' : 'back')

const getChild = (top, path) =>
  top.find((child) => child.id === path).childOptions

const itemsAtPath = (tree, path) => path.reduce(getChild, tree)

const backButton = (tree, path, onPathChange, highlightedFileID) => {
  const previousPath = path.slice(0, -1)
  const previousItem = itemsAtPath(tree, previousPath).find(
    (item) => item.id === path[path.length - 1]
  )
  if (path.length) {
    const reverser = onPathChange.bind(this, previousPath)
    return (
      <FileListItem
        key={previousItem.id}
        deep={path.length > 1}
        highlighted={previousItem.id === highlightedFileID}
        isReversible={true}
        onClick={reverser}
        onReverse={reverser}
        {...previousItem}
      />
    )
  }
  return null
}

const errorMsg = (error) => (
  <Conditional condition={error}>
    <ErrorDisplay error={error} />
  </Conditional>
)

const fileBrowser = (
  error,
  lastPath,
  currentPath,
  scrollToIndex,
  fileTree,
  onPathChange,
  highlightedFileID,
  renderedItems
) => (
  <Conditional condition={!error}>
    <div className={kuiperClassNames('file-browser')}>
      <TransitionGroup
        className={kuiperClassNames('file-browser-transition-group')}
      >
        <CSSTransition
          classNames={transitionName(lastPath, currentPath)}
          timeout={150}
        >
          <InfiniteList
            key={currentPath.length}
            rowHeight={26}
            scrollToIndex={scrollToIndex}
          >
            {backButton(fileTree, currentPath, onPathChange, highlightedFileID)}
            {renderedItems}
          </InfiniteList>
        </CSSTransition>
      </TransitionGroup>
    </div>
  </Conditional>
)

const FileList = ({
  currentPath,
  error,
  fileTree,
  highlightedFileID,
  lastPath,
  loaded,
  onPathChange,
  renderer,
  scrollToIndex,
}) => {
  const items = itemsAtPath(fileTree, currentPath)
  const renderedItems = items.map(renderer)

  return (
    <div className={kuiperClassNames('file-tree')}>
      {errorMsg(error)}
      {fileBrowser(
        error,
        lastPath,
        currentPath,
        scrollToIndex,
        fileTree,
        onPathChange,
        highlightedFileID,
        renderedItems
      )}
      <Loader theme="white" loaded={loaded} />
    </div>
  )
}

FileList.propTypes = {
  currentPath: array,
  error: string,
  fileTree: array,
  highlightedFileID: string,
  lastPath: array,
  loaded: bool,
  onPathChange: func,
  renderer: func,
  scrollToIndex: number,
}

export default FileList
